import { render } from "./agentSerial.vue?vue&type=template&id=27c85f82&scoped=true"
import script from "./agentSerial.vue?vue&type=script&lang=js"
export * from "./agentSerial.vue?vue&type=script&lang=js"

import "./agentSerial.vue?vue&type=style&index=0&id=27c85f82&scoped=true&lang=css"
import "./agentSerial.vue?vue&type=style&index=1&id=27c85f82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27c85f82"

export default script